import React from 'react'
import { useConfiguration } from '../AppConfigProvider/AppConfigProvider'
import { initBranch } from '../../services/branch.service'

// initialize Branch
const Branch: React.FC = () => {
  const { configuration } = useConfiguration()
  initBranch(configuration)

  return <></>
}

export default Branch
